'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const Portal: React.FC<{
  children: React.ReactNode;
}> = ({
  children,
}) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      setMounted(true);
    }, []);

    if (!mounted) return null;
    return createPortal(children, document.body);
  };
